import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as EditIcon } from './icons/edit.svg';

export default function Edit() {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      <EditIcon />
      <span className="underline"> {t('edit')}</span>
    </div>
  );
}
